import { render } from "./DisplayImageDetails.vue?vue&type=template&id=71ccda34&scoped=true"
import script from "./DisplayImageDetails.vue?vue&type=script&lang=js"
export * from "./DisplayImageDetails.vue?vue&type=script&lang=js"

import "./DisplayImageDetails.vue?vue&type=style&index=0&id=71ccda34&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ccda34"]])

export default __exports__